import { z } from 'zod';

export const USER_ACCESS_WORKBOOK_TABS = ['profile', 'memberships', 'entitlements', 'review'] as const;
export type UserAccessWorkbookTab = (typeof USER_ACCESS_WORKBOOK_TABS)[number];

export const UserAccessWorkbookPayloadSchema = z.object({
  /** Existing user to load. When present, tabs 2-4 are unlocked. */
  user_id: z.string().min(1).optional(),
  /** Tab to activate on open. Defaults to 'profile'. */
  tab: z.enum(USER_ACCESS_WORKBOOK_TABS).optional(),
});

export type UserAccessWorkbookPayload = z.infer<typeof UserAccessWorkbookPayloadSchema>;
